<template>
  <button @click="toggle(index)" :class="buttonStyles">
    <div :class="buttonTextStyles">
      {{ ctaLabel }}
    </div>
    <div :class="iconStyles">
      <!-- <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3431 5.3431L8.00981 10.6764L2.67647 5.3431"
          stroke-width="3"
        />
      </svg> -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M8.01465 3.98535L16.0146 11.9854L8.01465 19.9854"
          stroke-width="3"
        />
      </svg>
    </div>
  </button>
  <sub-navigation :links="links" :isOpen="showSubNav" classes="lg:hidden" />
</template>

<script setup lang="ts">
import { computed, toRefs } from "vue";
import { INavLink } from "@/types/components/INavigationProps";
import SubNavigation from "@organisms/Navigation/SubNavigation.vue";

export interface INavButtonProps {
  ctaLabel: string;
  index: number;
  activeIndex: number;
  links?: INavLink[];
  showSubNav: boolean;
  classes?: string;
}

const props = withDefaults(defineProps<INavButtonProps>(), {
  showSubNav: false,
});
const { ctaLabel, links, index, showSubNav, activeIndex, classes } =
  toRefs(props);

type Emits = {
  (e: "toggle", idx: number): void;
};
const emit = defineEmits<Emits>();

const toggle = (idx: number) => {
  emit("toggle", idx);
};

const linkColor = computed(() => {
  return activeIndex.value !== -1 && showSubNav.value
    ? "text-white stroke-white"
    : activeIndex.value === -1
    ? "text-white stroke-white"
    : "text-white-50 stroke-white-50 group-hover:text-white group-hover:stroke-white";
});

const iconStyles = computed(() => {
  const angle = showSubNav.value
    ? "-rotate-90 lg:rotate-0"
    : "rotate-90 lg:rotate-0";
  return `w-8 h-8 transform ${angle} group-focus:stroke-white group-active:stroke-white flex items-center  justify-center linkTransition ${linkColor.value}`;
});

const buttonStyles = computed(() => {
  return `group flex items-center pb-5 lg:pb-8 linkTransition`;
});

const buttonTextStyles = computed(() => {
  return `text-nav-mobile font-bold mr-6 lg:text-nav group-active:text-white group-focus:text-white linkTransition ${linkColor.value}`;
});
</script>
